import React, { Component, forwardRef, Fragment } from "react";
import DatePicker from "react-datepicker";
import { Redirect, withRouter } from "react-router-dom";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import { years, months, isWeekday } from "../../../utils/CalendarHelpers";
import { getMonth, getYear } from "date-fns";
import { get } from "../../../utils/DeApi";
import { exportDocuments } from "../../../utils/exportUtils";

import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import SelectionsList from "../SelectionsList/SelectionsList";
import CatalogueAssembly from "../CatalogueAssembly/CatalogueAssembly";
import "./SelectionsReview.scss";

class SelectionsReview extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      filings: [],
      catalogue: [],
      selections: [],
      selectedDocs: [],
      selectedFilter: "filedAt",
      filingDate:
        localStorage.getItem("filedAt") !== undefined &&
        localStorage.getItem("filedAt") !== null
          ? localStorage.getItem("filedAt")
          : moment().format("YYYY-MM-DD"),
    };
  }

  componentDidMount() {
    this.fetchCatalogue();
    this.fetchSelections();
    this.searchFullTextFilings();
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function (promise) {
      promise.cancel();
    });
  }

  fetchFilings(selected) {
    const { filingDate } = this.state;
    let url = "/search/filings";
    if (!selected.length) {
      this.setState({ selections: [], error: null, isLoading: false });
      return;
    }
    this.setState({ error: null, isLoading: true });

    const accessionNos = selected.map(
      (item) => 'accessionNo:"' + item.filingId + '"'
    );
    if (this.props?.optimization) {
      url = "/search/newcron/filings";
    }
    const filingsQuery = accessionNos.length ? accessionNos.join(" OR ") : "";
    const searchFilingsPromise = get(url, {
      // when the filter is created At then we will not send filedAt attribute
      params: {
        ...(this.state.selectedFilter === "filedAt" && { filedAt: filingDate }),
        q: filingsQuery,
        filedAt: filingDate,
        offset: 0,
        limit: 2000,
      },
    });
    searchFilingsPromise.promise
      .then((response) => {
        var filings = response.data;
        this.setState({
          selections: selected
            .map((item) => {
              return {
                ...item,
                ...{
                  filing: filings.find((filing) => {
                    return filing.documentFormatFiles
                      ? filing.documentFormatFiles.find(
                          (matched) =>
                            filing.accessionNo === item.filingId &&
                            matched.documentId === item.documentId
                        )
                      : null;
                  }),
                },
              };
            })
            .filter(
              (catalogued) => !!catalogued.filing && !!catalogued.formType
            ),
          filingsMeta: response.meta,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
  }

  searchFullTextFilings() {
    const { filedAt } = this.props;
    this.setState({ error: null, isLoading: true });

    var searchFilingsPromise = null;

    searchFilingsPromise = get("/search/newcron/filings", {
      params: { filedAt: filedAt, offset: 0, limit: 5000 },
    });

    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          filings: response.data,
          searchContainer: response.data,
          filingsMeta: response.meta,
          error: null,
          isLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            error: { message: error.code, code: error.code },
            isLoading: false,
          });
      });
    this.subscribedPromises.push(searchFilingsPromise);
  }

  fetchSelections() {
    const { filingDate } = this.state;
    this.setState({ error: null, isLoading: true });

    const searchFilingsPromise = get("/catalogues", {
      params: { [this.state.selectedFilter]: filingDate },
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.fetchFilings(response.data);
      })
      .catch((error) => {
        !error.isCanceled && this.setState({ error: error, isLoading: false });
      });
  }

  fetchCatalogue(filingDate = null) {
    const { filedAt } = this.props;
    this.setState({ catalogueError: null, catalogueIsLoading: true });

    const searchFilingsPromise = get("/catalogues", {
      params: {
        filedAt: filingDate !== null ? filingDate : filedAt,
        inventories: [
          "609a925cd40db",
          "609a925ccd422",
          "609a925cc94f7",
          "609a925ccf235",
          "609a925cd1714",
        ],
      },
    });
    searchFilingsPromise.promise
      .then((response) => {
        this.setState({
          catalogue: response.data,
          catalogueError: null,
          catalogueIsLoading: false,
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({ catalogueError: error, catalogueIsLoading: false });
      });
  }

  exportFilings() {
    const { selections } = this.state;

    const { filedAt } = this.props;

    const fileName = `${filedAt}-selections.csv`;
    exportDocuments(selections, fileName);
  }

  handleFilterChange = (e) => {
    this.setState(
      {
        selectedFilter: e.target.checked ? "createdAt" : "filedAt",
      },
      this.fetchSelections
    );
  };

  render() {
    const { filedAt } = this.props;
    const {
      selections,
      catalogue,
      isLoading,
      error,
      selectedDocs,
      filings,
      filingsMeta,
      selectedFilter,
    } = this.state;

    if (isLoading) return <Loader />;
    if (error) return <ErrorHandler error={error} />;
    return (
      <>
        <Row className="mt-1 selections-review-header-section pb-3">
          <div className="col-md-9">
            {this.renderDateSelector()}{" "}
            {/* *** <<< selection page date picker only *** */}
            {/* <h5 className="mt-3">
              
              <div className="custom-control custom-switch flow-control" style={{marginLeft: "1%"}}>
              <input type="checkbox" 
                checked={this.state.selectedFilter === "createdAt"}
                className="custom-control-input" id="customSwitches" 
                value={"queryByFetch"} 
                onChange={this.handleFilterChange}
                aria-label="select"
                />
              <label className="custom-control-label" htmlFor="customSwitches">{" "}Filter by creation date</label>
            </div>
            </h5> */}
          </div>

          {/* <small className="float-right"> */}
          {!!selections.length && (
            <div className="col-md-3">
              <CatalogueAssembly
                filedAt={filedAt}
                selectedDocs={selectedDocs}
                selections={catalogue}
                onCatalogueAssembled={() => this.fetchCatalogue()}
              />
              {/* <Button
                      variant="success"
                      size="sm"
                      className="ml-2"
                      onClick={() => this.exportFilings()}
                    >
                      Export{" "}
                      <span className="material-icons md-18">download</span>
                    </Button>{" "} */}
              <a
                href="#"
                className="override-anchor-effect custom-adjustment"
                onClick={() => this.exportFilings()}
                style={{ marginTop: "2%" }}
              >
                Export{" "}
                <span className="material-icons color-deal-style">
                  description
                </span>
              </a>
            </div>
          )}
          {/* </small> */}

          <hr />
        </Row>
        <Row className="selections-table">
          <Col xs={12} className="mb-3">
            <SelectionsList
              catalogue={catalogue}
              user={this.props?.user}
              selectedFilter={selectedFilter}
              filings={filings}
              filingsMeta={filingsMeta}
              selections={selections || []}
              onCatalogueAdd={(catalogued) => {
                this.setState({ selections: [...selections, ...[catalogued]] });
              }}
              onCatalogueRemove={(catalogued) => {
                this.setState({
                  selections: selections.filter(
                    (item) => item.id !== catalogued.id
                  ),
                });
              }}
              selectedDocs={selectedDocs}
              onDocumentsSelected={(selectedDocs) => {
                this.setState({ selectedDocs: selectedDocs });
              }}
            />
          </Col>
        </Row>
      </>
    );
  }

  setRefDate(date) {
    let formatted = moment(date).format("YYYY-MM-DD");
    this.setState({ filingDate: formatted }, () => {
      localStorage.setItem("filedAt", formatted);
      this.fetchSelections();
      this.fetchCatalogue(formatted);
    });
  }

  renderDateSelector() {
    const { filingDate } = this.state;

    // if (filingDate) return <Redirect push to={`/selections/show/${filingDate}`} />;

    const DateInput = forwardRef(({ value, onClick }, ref) => (
      <button
        className="btn btn-success-deal-style roundedEdges shadow"
        onClick={onClick}
      >
        {value}
        <span className="material-icons">expand_more</span>
      </button>
    ));

    return (
      <DatePicker
        portalId="root-portal"
        filterDate={isWeekday}
        dayClassName={() => {
          return "text-dark";
        }}
        onChange={(date) => {
          this.setRefDate(date);
        }}
        customInput={<DateInput />}
        popperPlacement="right-start"
        className="btn-block bring-to-front"
        selected={moment(filingDate).toDate()}
        renderCustomHeader={({
          date,
          changeYear,
          changeMonth,
          decreaseMonth,
          increaseMonth,
          prevMonthButtonDisabled,
          nextMonthButtonDisabled,
        }) => (
          <div
            style={{ margin: 10, display: "flex", justifyContent: "center" }}
          >
            <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
              {" "}
              {"<"}{" "}
            </button>
            <select
              value={getYear(date)}
              onChange={({ target: { value } }) => changeYear(value)}
            >
              {years.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <select
              value={months[getMonth(date)]}
              onChange={({ target: { value } }) =>
                changeMonth(months.indexOf(value))
              }
            >
              {months.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
              {" "}
              {">"}{" "}
            </button>
          </div>
        )}
      />
    );
  }
}

SelectionsReview.propTypes = {};

export default withRouter(SelectionsReview);
